import { Link } from 'react-router-dom';
import { ProductBrand } from '@/components/brand/ProductBrand';
import { SignOutButton } from '@/components/auth/SignOutButton';
import { Card, CardHeader } from '@/components/ui/Card';
import { cn } from '@/utils/cn';

export function Dashboard() {
  return (
    <div className="min-h-screen bg-page">
      <header className="border-b border-border bg-surface shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex items-center justify-between gap-4">
          <ProductBrand variant="light" />
          <SignOutButton />
        </div>
      </header>

      <main className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
        <div className="space-y-6">
          <Card>
            <CardHeader>
              <h2 className="font-semibold text-foreground mb-2">Advertising accounts</h2>
              <p className="text-body-sm text-foreground-muted mb-4">Manager accounts and SP campaigns.</p>
              <Link
                to="/accounts"
                className={cn(
                  'inline-flex items-center gap-2 rounded-lg bg-brand px-4 py-2 text-sm font-semibold text-brand-foreground',
                  'hover:bg-brand-hover transition-colors'
                )}
              >
                Open accounts →
              </Link>
            </CardHeader>
          </Card>
        </div>
      </main>
    </div>
  );
}
